import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getSendbirdBatchMessageInfo({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.multi_message.info, id, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getSendbirdBatchMessageInfoDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSendbirdBatchMessageInfoFailed,
      endpoint: api.sendbird.multi_message.info.url
    });
  }
}

export const getSendbirdBatchMessageInfoSaga = takeEvery(types.GET_SENDBIRD_BATCH_MESSAGE_INFO_REQUEST, getSendbirdBatchMessageInfo);